import { render } from "./DsoRiderStepThree.vue?vue&type=template&id=34e42a67&scoped=true"
import script from "./DsoRiderStepThree.vue?vue&type=script&lang=js"
export * from "./DsoRiderStepThree.vue?vue&type=script&lang=js"

import "./DsoRiderStepThree.vue?vue&type=style&index=0&id=34e42a67&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e42a67"]])

export default __exports__